import { OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  header: 'Tilaushistoria',
  labels: {
    dummy_order: 'Testitilaus',
    orders_number: 'Tilausten määrä ({{count}})',
    revenue: 'Liikevaihto: {{amount}}',
    tips: 'Tipit: {{amount}}',
    cash_sales: ' ({{amount}} käteinen)',
    refunds: 'Hyvitykset: {{count}} ({{amount}})',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Nouto',
    [OrderMethod.Delivery]: 'Toimitus',
    [OrderMethod.OnSite]: 'Pöytätilaus',
  },
  statuses: {
    [OrderFulfillmentStatus.Created]: 'Käynnissä',
    [OrderFulfillmentStatus.Reviewed]: 'Käynnissä',
    [OrderFulfillmentStatus.Accepted]: 'Käynnissä',
    [OrderFulfillmentStatus.Preparing]: 'Käynnissä',
    [OrderFulfillmentStatus.Ready]: 'Käynnissä',
    [OrderFulfillmentStatus.OnDelivery]: 'Käynnissä',
    [OrderFulfillmentStatus.Picked]: 'Valmis',
    [OrderFulfillmentStatus.Rejected]: 'Hylätty',
  },
  payment_methods: {
    invoice: 'Lasku',
    cash: 'Käteinen',
    online: 'Verkkomaksu',
  },
  filters: {
    all: 'Kaikki',
  },
  fields: {
    order_placed: 'Tilaus tehty',
    order_number: '#',
    customer: 'Asiakas',
    payment_method: 'Maksutapa',
    method: 'Tyyppi',
    status: 'Tila',
    total: 'Yhteensä',
  },
  buttons: {
    print: 'Tulosta',
    create_test_order: 'Luo testitilaus',
  },
  toasts: {
    failed_to_fetch_orders:
      'Tietojen lataus epäonnistui. Napsauta päivityskuvaketta tai yritä uudelleen minuutin kuluttua.',
    something_went_wrong: 'Jokin meni pieleen, yritä uudelleen.',
    failed_to_create_test_order: 'Testitilauksen luonti epäonnistui',
    test_order_created: 'Testitilaus luotu',
  },
};
